import React, { useState } from 'react'

const SportsBeerLoadMore: React.FC = () => {
  const [visible, setVisible] = useState(true)

  const handleClick = () => {
    document.querySelectorAll('.js-hidden-item').forEach((item, index) => {
      item.classList.remove('hidden-item')
      ;(item as HTMLElement).style.animationDelay = `${index * 0.1}s`
    })
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="relative inline-block group mt-[37px] lg:mt-[58px] px-10 lg:px-0 w-full lg:w-auto">
      <button
        onClick={handleClick}
        className="flex justify-center items-center font-bn-dime text-[29px] font-normal tracking-[0.29px] uppercase py-[28px] px-[32px] lg:px-[64px] relative text-center w-full"
      >
        <span className="absolute w-full h-full inset-0 z-[1] text-[#3E2F3D] border-[6px] border-[#3E2F3D] bg-[#FF755A] [filter:drop-shadow(-8px_11px_0_currentColor)] skew-x-[10deg]" />
        <span className="w-full relative z-[2] text-[#3E2F3D]">LOAD MORE</span>
      </button>
    </div>
  )
}

export default SportsBeerLoadMore
